var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a;
import { CHAINID } from "../utils/env";
import deployment from "./lendDeployments.json";
export var NETWORKS = (_a = {},
    _a[CHAINID.ETH_MAINNET] = "mainnet",
    _a);
export var PoolVersionList = ["lend"];
export var EVMPoolList = ["wintermute", "folkvang"];
var AllPoolOptions = __spreadArray([], EVMPoolList);
// @ts-ignore
export var PoolList = EVMPoolList;
export var PoolAddressMap = {
    wintermute: {
        lend: deployment.mainnet.wintermute,
        chainId: CHAINID.ETH_MAINNET,
    },
    folkvang: {
        lend: deployment.mainnet.folkvang,
        chainId: CHAINID.ETH_MAINNET,
    },
};
export var getAssets = function (pool) {
    return "USDC";
};
export var getCredoraName = function (pool) {
    switch (pool) {
        case "wintermute":
            return "Wintermute Trading Ltd";
        case "folkvang":
            return "Folkvang";
    }
};
export var getDisplayAssets = function (pool) {
    return "USDC";
};
//# sourceMappingURL=lendConstants.js.map